(function (angular) {
    angular
        .module('harriApp')
        .controller('JobSponsorModal', [
            '$scope', 'modalData',
            function ($scope, modalData) {
                var self = this;
                self.service = modalData.service;

                //Hide modal
                self.hideModal = function () {
                    $scope.$hide();
                };

                var init = function () {
                    self.loading = false;
                };

                init();
            }]);
})
(angular);

